import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { Actions, Store, ofActionSuccessful } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { BUNDLE_NAMES, DRB_ID_TYPE } from 'src/app/shared/constants/general-constants';
import { Drb } from 'src/app/models/drb-models/drb';
import { DrbState, LoadDrbByVersionSuccess } from '../../redux';
import { ViewXliffComponent } from '../../drb-xliff/view-xliff/view-xliff.component';
import { ViewSourceItemComponent } from '../../drb-sources/source-item/view-source-item/view-source-item.component';
import { ViewImageComponent } from '../../drb-sources/source-images/view-image/view-image.component';

@Component({
  selector: 'app-modal-container-drb',
  template: ''
})
export class ModalContainerDrbComponent implements OnDestroy, OnInit {
  public marketing$: Observable<Drb> = inject(Store).select(DrbState.marketing);
  public marketing_translations$: Observable<Drb> = inject(Store).select(DrbState.marketing_translations);
  private unsubscribe = new Subject<void>();

  public tableData?: Drb;
  public bundle_name?: String;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: NbDialogService,
    private actions$: Actions
  ) {}

  public ngOnInit() {
    this.route.parent.params.pipe(takeUntil(this.unsubscribe)).subscribe((params) => {
      this.bundle_name = params.bundle_name;

      if (this.bundle_name === BUNDLE_NAMES.MARKETING) {
        this.marketing$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.tableData = data));
      } else if (this.bundle_name === BUNDLE_NAMES.MARKETING_TRANSLATIONS) {
        this.marketing_translations$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.tableData = data));
      }
    });

    this.route.params.pipe(takeUntil(this.unsubscribe)).subscribe((params) => {
      const type = params.type;
      const id = params.id;
      let found;

      if (this.tableData) {
        switch (type) {
          case DRB_ID_TYPE.STRING:
            found = this.tableData.xliff.en.find((x) => x.id === id);
            break;
          case DRB_ID_TYPE.FILE:
            found = this.tableData.source.files.find((x) => x.id === id);
            break;
          case DRB_ID_TYPE.IMAGE:
            found = this.tableData.source.images.find((x) => x.id === id);
            break;
          case DRB_ID_TYPE.LINK:
            found = this.tableData.source.links.find((x) => x.id === id);
            break;
          case DRB_ID_TYPE.VIDEO:
            found = this.tableData.source.videos.find((x) => x.id === id);
            break;
        }
        if (found) {
          switch (type) {
            case DRB_ID_TYPE.STRING:
              this.dialogService
                .open(ViewXliffComponent, {
                  closeOnEsc: false,
                  closeOnBackdropClick: false,
                  context: {
                    xliff: found
                  }
                })
                .onClose.subscribe(() => this.router.navigateByUrl(`drb/${this.bundle_name}/view`));
              break;
            case DRB_ID_TYPE.FILE:
              this.dialogService
                .open(ViewSourceItemComponent, {
                  closeOnEsc: false,
                  closeOnBackdropClick: false,
                  context: {
                    sourceItem: found,
                    type: type
                  }
                })
                .onClose.subscribe(() => this.router.navigateByUrl(`drb/${this.bundle_name}/view`));
              break;
            case DRB_ID_TYPE.IMAGE:
              this.dialogService
                .open(ViewImageComponent, {
                  closeOnEsc: false,
                  closeOnBackdropClick: false,
                  context: {
                    image: JSON.parse(JSON.stringify(found))
                  }
                })
                .onClose.subscribe(() => this.router.navigateByUrl(`drb/${this.bundle_name}/view`));
              break;
            case DRB_ID_TYPE.LINK:
              this.dialogService
                .open(ViewSourceItemComponent, {
                  closeOnEsc: false,
                  closeOnBackdropClick: false,
                  context: {
                    sourceItem: found,
                    type: type
                  }
                })
                .onClose.subscribe(() => this.router.navigateByUrl(`drb/${this.bundle_name}/view`));
              break;
            case DRB_ID_TYPE.VIDEO:
              this.dialogService
                .open(ViewSourceItemComponent, {
                  closeOnEsc: false,
                  closeOnBackdropClick: false,
                  context: {
                    sourceItem: found,
                    type: type
                  }
                })
                .onClose.subscribe(() => this.router.navigateByUrl(`drb/${this.bundle_name}/view`));
              break;
          }
        } else {
          this.router.navigateByUrl(`drb/${this.bundle_name}/view`);
        }
      } else {
        this.actions$
          .pipe(ofActionSuccessful(LoadDrbByVersionSuccess), take(1), takeUntil(this.unsubscribe))
          .subscribe(() => {
            switch (type) {
              case DRB_ID_TYPE.STRING:
                found = this.tableData.xliff.en.find((x) => x.id === id);
                break;
              case DRB_ID_TYPE.FILE:
                found = this.tableData.source.files.find((x) => x.id === id);
                break;
              case DRB_ID_TYPE.IMAGE:
                found = this.tableData.source.images.find((x) => x.id === id);
                break;
              case DRB_ID_TYPE.LINK:
                found = this.tableData.source.links.find((x) => x.id === id);
                break;
              case DRB_ID_TYPE.VIDEO:
                found = this.tableData.source.videos.find((x) => x.id === id);
                break;
            }
            if (found) {
              switch (type) {
                case DRB_ID_TYPE.STRING:
                  this.dialogService
                    .open(ViewXliffComponent, {
                      closeOnEsc: false,
                      closeOnBackdropClick: false,
                      context: {
                        xliff: found
                      }
                    })
                    .onClose.subscribe(() => this.router.navigateByUrl(`drb/${this.bundle_name}/view`));
                  break;
                case DRB_ID_TYPE.FILE:
                  this.dialogService
                    .open(ViewSourceItemComponent, {
                      closeOnEsc: false,
                      closeOnBackdropClick: false,
                      context: {
                        sourceItem: found,
                        type: type
                      }
                    })
                    .onClose.subscribe(() => this.router.navigateByUrl(`drb/${this.bundle_name}/view`));
                  break;
                case DRB_ID_TYPE.IMAGE:
                  this.dialogService
                    .open(ViewImageComponent, {
                      closeOnEsc: false,
                      closeOnBackdropClick: false,
                      context: {
                        image: JSON.parse(JSON.stringify(found))
                      }
                    })
                    .onClose.subscribe(() => this.router.navigateByUrl(`drb/${this.bundle_name}/view`));
                  break;
                case DRB_ID_TYPE.LINK:
                  this.dialogService
                    .open(ViewSourceItemComponent, {
                      closeOnEsc: false,
                      closeOnBackdropClick: false,
                      context: {
                        sourceItem: found,
                        type: type
                      }
                    })
                    .onClose.subscribe(() => this.router.navigateByUrl(`drb/${this.bundle_name}/view`));
                  break;
                case DRB_ID_TYPE.VIDEO:
                  this.dialogService
                    .open(ViewSourceItemComponent, {
                      closeOnEsc: false,
                      closeOnBackdropClick: false,
                      context: {
                        sourceItem: found,
                        type: type
                      }
                    })
                    .onClose.subscribe(() => this.router.navigateByUrl(`drb/${this.bundle_name}/view`));
                  break;
              }
            } else {
              this.router.navigateByUrl(`drb/${this.bundle_name}/view`);
            }
          });
      }
    });
  }

  public ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
